import Vue from 'vue';

export const CourseHomeIconMap = {
  1: require('@/assets/images/icons/ic-kejian.png'), // interact          课件
  2: require('@/assets/images/icons/ic-ziliao.png'), // courseware        资料
  3: require('@/assets/images/icons/ic-hudong.png'), // interactestpaper 互动答题
  4: require('@/assets/images/icons/ic-zuoye.png'), // homework          作业
  5: require('@/assets/images/icons/ic-huati.png'), // topic             话题
  6: require('@/assets/images/icons/ic-ceshi.png'), // testpaper         测试
  7: require('@/assets/images/icons/ic-gonggao.png'), // announce          公告
  8: require('@/assets/images/icons/file_ext_small_link.png'), // courseware        资料(直播 、录屏)
  9: require('@/assets/images/icons/ic-ziliao.png'), //慕课资料
  10: require('@/assets/images/icons/ic-ziliao.png'), //慕课外链
  20: require('@/assets/images/icons/ic-ziliao.png'), // courseware        资料(直播 、录屏)
  21: require('@/assets/images/icons/ic-ziliao.png'), // courseware        资料(直播 、录屏)
  22: require('@/assets/images/icons/ic-huiyi.png'), // 腾讯会议
  25: require('@/assets/images/icons/ic-casestudy.png') // 案例学习
};
// 对应名称
export const CourseHomeNameMap: { [key: number]: string } = {
  1: '课件', // interact          课件
  2: '资料', // courseware        资料
  3: '互动答题', // interactestpaper 互动答题
  4: '作业', // homework          作业
  5: '话题', // topic             话题
  6: '测试', // testpaper         测试
  7: '公告', // announce          公告
  8: '资料', // courseware          资料
  9: '慕课视频', // courseware          资料
  10: '慕课外链', // courseware          资料
  20: '直播',
  21: '录播',
  22: '腾讯会议',
  25: '案例学习'
};

export interface CoursePathItem {
  teacher: string;
  student: string;
}
export interface CourseDataItem {
  name: string;
  iconClass: string;
  path: string | CoursePathItem;
  editPath?: string | CoursePathItem;
  publishPath?: string | CoursePathItem; // 发布按钮地址
  createPath?: string | CoursePathItem;
}

export interface InterfaceCourseHomeData {
  0: CourseDataItem; // interact          全部
  1: CourseDataItem; // interact          课件
  2: CourseDataItem; // courseware        资料
  3: CourseDataItem; // interactestpaper 互动答题
  4: CourseDataItem; // homework          作业
  5: CourseDataItem; // topic             话题
  6: CourseDataItem; // testpaper         测试
  7: CourseDataItem; // announce          公告
  8: CourseDataItem; // courseware          资料-视频录播
  9: CourseDataItem; // 慕课资料          
  10: CourseDataItem; // 慕课外链
  20: CourseDataItem; // 直播视屏
  21: CourseDataItem; // 录播视屏
  22: CourseDataItem; // courseware          腾讯会议
  25: CourseDataItem; // courseware          案例学习
}
// 课堂内容跳转地址
// path：string
// editPath: string
// 若要区分学生端和老师端分别跳转，
// path: { teacher: '',student: '' }
export const CourseHomeDataMap: InterfaceCourseHomeData = {
  0: {
    name: '全部',
    iconClass: require('@/assets/images/icons/icon-mulu.svg'),
    path: '/courseHome'
  },
  1: {
    name: CourseHomeNameMap[1],
    iconClass: CourseHomeIconMap[1],
    path: {
      teacher: '/courseware/detail',
      student: '/courseware/startLearning'
    },
    createPath: '/addActivity/importType?source=1',
    editPath: '/addActivity/courseware?courseType=2',
    publishPath: {
      teacher: '/addActivity/courseware?courseType=3',
      student: '/courseware/startLearning'
    }
  }, // interact          课件
  2: {
    name: CourseHomeNameMap[2],
    iconClass: CourseHomeIconMap[2],
    path: '/dataIndex?type=2',
    createPath: '/addActivity/importType?source=2&importTypeHasMuke=1',
    editPath: '/addActivity/data?dataType=2&type=1', // type 1 普通资料
    publishPath: '/addActivity/data?dataType=3&type=1'
  }, // courseware        资料
  3: {
    name: CourseHomeNameMap[3],
    iconClass: CourseHomeIconMap[3],
    path: {
      teacher: '/InteractiveAnswers/detailTeacher',
      student: '/InteractiveAnswers/detail'
    },
    createPath: '/courseware/importFile?source=3',
    editPath: '/addActivity/interactiveAnswers?answerTye=2',
    publishPath: {
      teacher: '/addActivity/interactiveAnswers?answerTye=3',
      student: '/InteractiveAnswers/detail'
    }
  }, // interactestpaper 互动答题
  4: {
    name: CourseHomeNameMap[4],
    iconClass: CourseHomeIconMap[4],
    path: '/homework',
    editPath: '/addActivity/task?submitType=1',
    publishPath: '/addActivity/task?submitType=2',
    createPath: '/addActivity/importType?source=4'
  }, // homework          作业
  5: {
    name: CourseHomeNameMap[5],
    iconClass: CourseHomeIconMap[5],
    path: '/topicDetail',
    createPath: '/addActivity/topic?source=5',
    editPath: '/addActivity/topic?topicType=2',
    publishPath: '/addActivity/topic?topicType=3'
  }, // topic             话题
  6: {
    name: CourseHomeNameMap[6],
    iconClass: CourseHomeIconMap[6],
    path: {
      teacher: '/testing/detail',
      student: '/testing/stu/detail'
    }, // '/testing/detail'
    createPath: '/courseware/importFile?source=6',
    editPath: '/testing/create',
    publishPath: {
      teacher: '/testing/create',
      student: '/testing/stu/detail'
    }
  }, // testpaper         测试
  7: {
    name: CourseHomeNameMap[7],
    iconClass: CourseHomeIconMap[7],
    path: '/noticeDetail',
    createPath: '/addActivity/notice?source=7',
    editPath: '/addActivity/notice?noticeType=2',
    publishPath: '/addActivity/notice?noticeType=3'
  }, // announce          公告
  8: {
    name: CourseHomeNameMap[8],
    iconClass: CourseHomeIconMap[8],
    path: '/dataIndex?type=8',
    createPath: '/addActivity/importType?source=2',
    editPath: '/addActivity/data?dataType=2&type=2', // type 2 外链资料
    publishPath: '/addActivity/data?dataType=3&type=2'
  }, // 资料
  9: {
    name: CourseHomeNameMap[2],
    iconClass: CourseHomeIconMap[2],
    path: '/dataIndex?type=9',
    createPath: '/addActivity/importType?source=2',
    editPath: '/addActivity/data?dataType=2&type=1&contenttype=9', 
    publishPath: '/addActivity/data?dataType=3&type=1&contenttype=9'
  }, // 慕课资料
  10: {
    name: CourseHomeNameMap[2],
    iconClass: CourseHomeIconMap[2],
    path: '/dataIndex?type=10',
    createPath: '/addActivity/importType?source=2',
    editPath: '/addActivity/data?dataType=2&type=1&contenttype=10', 
    publishPath: '/addActivity/data?dataType=3&type=1&contenttype=10'
  }, // 慕课外链
  // 直播视频
  20: {
    name: CourseHomeNameMap[8],
    iconClass: CourseHomeIconMap[8],
    path: '/dataIndex?type=20',
    createPath: '/addActivity/importType?source=2',
    editPath: '/addActivity/data?dataType=2&type=2',
    publishPath: '/addActivity/data?dataType=3&type=2'
  },
  // 录播视频
  21: {
    name: CourseHomeNameMap[8],
    iconClass: CourseHomeIconMap[8],
    path: '/dataIndex?type=21',
    createPath: '/addActivity/importType?source=2',
    editPath: '/addActivity/data?dataType=2&type=2',
    publishPath: '/addActivity/data?dataType=3&type=2'
  },
  22: {
    name: CourseHomeNameMap[22],
    iconClass: CourseHomeIconMap[22],
    path: '/conference',
    createPath: '/addActivity/conference?source=21&submitType=0',
    editPath: '/addActivity/conference?submitType=1',
    publishPath: '/addActivity/conference?submitType=2'
  }, // 腾讯会议
  25: {
    name: CourseHomeNameMap[25],
    iconClass: CourseHomeIconMap[25],
    path: '/casestudy',
    createPath: '/addActivity/importType?source=25',
    editPath: '/addActivity/casestudy?caseStudyType=2',
    publishPath: '/addActivity/casestudy?caseStudyType=3'
  } // 案例学习
};
